/* eslint-disable camelcase */
class DiscountModal {
  constructor () {
    const rawConfig = window.Tentbox?.discountModals || []
    const url = new URL(window.location.href)
    const triggerParam = url.searchParams.get('trigger')

    if (triggerParam) {
      this.rawModalConfig = rawConfig.find(m => m.trigger === triggerParam)
      if (this.rawModalConfig) {
        this.triggerKey = triggerParam
        this.init()
      }
    }
  }

  async init () {
    const freeGids = Array.isArray(this.rawModalConfig.free_product_gids)
      ? this.rawModalConfig.free_product_gids
      : []
    const qualifyGids = Array.isArray(this.rawModalConfig.qualifying_product_gids)
      ? this.rawModalConfig.qualifying_product_gids
      : []

    if (freeGids.length === 0 && qualifyGids.length === 0) {
      this.setupDataAndCheckCart([], [])
      return
    }

    const allGids = [...new Set([...freeGids, ...qualifyGids])]
    const query = `
      query getProductNodes($ids: [ID!]!) {
        nodes(ids: $ids) {
          __typename
          ... on Product {
            id
            variants(first: 1) {
              edges {
                node { id }
              }
            }
          }
        }
      }
    `
    const token = '2b4c864f0be40fb4d269690edae006c3'
    try {
      const resp = await fetch('/api/2025-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({ query, variables: { ids: allGids } }),
      })
      const json = await resp.json()
      if (json.errors) {
        this.setupDataAndCheckCart([], [])
        return
      }

      const productNodes = (json.data.nodes || []).filter(n => n.__typename === 'Product')
      const variantIdByGid = {}
      const numericIdByGid = {}

      productNodes.forEach(node => {
        const numericPid = parseInt(node.id.split('/').pop(), 10)
        numericIdByGid[node.id] = numericPid
        const edges = node.variants.edges
        if (edges.length > 0) {
          const variantGid = edges[0].node.id
          const numericVid = parseInt(variantGid.split('/').pop(), 10)
          variantIdByGid[node.id] = numericVid
        } else {
          variantIdByGid[node.id] = null
        }
      })

      const freeProductVariantIds = freeGids
        .map(gid => variantIdByGid[gid])
        .filter(id => Number.isInteger(id))

      const qualifyingProductIds = qualifyGids
        .map(gid => numericIdByGid[gid])
        .filter(id => Number.isInteger(id))

      this.setupDataAndCheckCart(freeProductVariantIds, qualifyingProductIds)
    } catch (err) {
      this.setupDataAndCheckCart([], [])
    }
  }

  setupDataAndCheckCart (freeVariantIds, qualifyingIds) {
    this.data = {
      trigger: this.rawModalConfig.trigger,
      freeProductVariantIds: freeVariantIds,
      qualifyingProductIds: qualifyingIds,
      scenarios: this.rawModalConfig.scenarios || {},
      discountCode: this.rawModalConfig.discount_code || '',
      proceedButtonText: this.rawModalConfig.proceed_button_text || 'Continue',
      tickElement: this.rawModalConfig.tick_element || '',
    }
    this.productBeingAdded = false
    this.isModalOpen = false
    this.isFreeProductInCart = false
    this.cartItems = []
    this.boundHandleModalClose = this.handleModalClose.bind(this)
    this.checkCartAndDiscount()
  }

  async checkCartAndDiscount () {
    try {
      const cartResponse = await fetch('/cart.js')
      const cart = await cartResponse.json()

      const freeProductInCart = this.data.freeProductVariantIds.some(vid =>
        cart.items.some(item => item.variant_id === vid),
      )
      const qualifyingProductInCart = cart.items.some(item =>
        this.data.qualifyingProductIds.includes(item.product_id),
      )

      this.cartItems = cart.items

      if (this.data.discountCode) {
        const isDiscountApplied = this.isDiscountCodeApplied(cart)
        if (!isDiscountApplied) {
          await this.applyDiscountCode()
          const updatedCartResponse = await fetch('/cart.js')
          const updatedCart = await updatedCartResponse.json()

          const isBXGYDiscount = updatedCart.discount_applications && updatedCart.discount_applications.some(discount =>
            discount.type === 'automatic' || discount.target_type === 'line_item',
          )

          this.cartItems = updatedCart.items
          const freeProductInUpdatedCart = this.data.freeProductVariantIds.some(vid =>
            updatedCart.items.some(item => item.variant_id === vid),
          )

          if (isBXGYDiscount && !freeProductInUpdatedCart) {
            // BXGY discount detected but free product not yet in cart
          } else if (!updatedCart.discount_applications) {
            if (!freeProductInUpdatedCart) {
              this.isFreeProductInCart = false
            } else {
              this.isFreeProductInCart = true
            }
          }
        }
      }

      this.showScenarioModal(freeProductInCart, qualifyingProductInCart)
    } catch (err) {
      this.showScenarioModal(false, false)
    }
  }

  isDiscountCodeApplied (cart) {
    if (!this.data.discountCode || !cart.discount_applications) {
      return false
    }
    return cart.discount_applications.some(discount => {
      return discount.code && discount.code.toLowerCase() === this.data.discountCode.toLowerCase()
    })
  }

  async applyDiscountCode () {
    if (!this.data.discountCode) return

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          discount: this.data.discountCode,
        }),
      })

      if (response.ok) {
        await response.json()
        await fetch('/cart.js')
        this.updateCartDrawer()
      }
    } catch (err) {}
  }

  async updateCartDrawer () {
    try {
      const sectionsResponse = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`)
      const sections = await sectionsResponse.json()

      if (sections['cart-drawer']) {
        const cartDrawerElement = document.getElementById('CartDrawer')
        if (cartDrawerElement) {
          const drawerInner = cartDrawerElement.querySelector('.drawer__inner')
          if (drawerInner) {
            const tempDiv = document.createElement('div')
            tempDiv.innerHTML = sections['cart-drawer']
            const newDrawerInner = tempDiv.querySelector('.drawer__inner')
            if (newDrawerInner) {
              drawerInner.innerHTML = newDrawerInner.innerHTML
            }
          }
        }
      }

      if (sections['cart-icon-bubble']) {
        const cartIconElement = document.getElementById('cart-icon-bubble')
        if (cartIconElement) {
          const tempDiv = document.createElement('div')
          tempDiv.innerHTML = sections['cart-icon-bubble']
          const newCartIcon = tempDiv.querySelector('.shopify-section')
          if (newCartIcon) {
            cartIconElement.innerHTML = newCartIcon.innerHTML
          }
        }
      }
    } catch (err) {}
  }

  decodeHtml (html) {
    const t = document.createElement('textarea')
    t.innerHTML = html
    return t.value
  }

  showScenarioModal (freeProductInCart, qualifyingProductInCart) {
    let scenarioContent = ''
    if (!freeProductInCart && !qualifyingProductInCart) {
      scenarioContent = this.data.scenarios.no_free_product_no_qualifying_product || ''
    } else if (freeProductInCart && !qualifyingProductInCart) {
      scenarioContent = this.data.scenarios.has_free_product_no_qualifying_product || ''
    } else if (!freeProductInCart && qualifyingProductInCart) {
      scenarioContent = this.data.scenarios.no_free_product_with_qualifying_product || ''
    } else {
      scenarioContent = this.data.scenarios.has_free_product_with_qualifying_product || ''
    }

    if (!scenarioContent) {
      this.cleanup()
      return
    }

    scenarioContent = this.decodeHtml(scenarioContent)

    let tickContainer = ''
    if (this.data.tickElement) {
      const tickEl = this.decodeHtml(this.data.tickElement)
      tickContainer = `<div class="flex justify-center py-8">${tickEl}</div>`
    }

    const centeredContent = `<div class="text-center">${scenarioContent}</div>`
    const proceedBtn = `<button type="button" class="button button-outline mt-3 w-full" id="discount-modal-proceed">${this.data.proceedButtonText}</button>`
    const modalInner = tickContainer + centeredContent + proceedBtn

    this.isFreeProductInCart = freeProductInCart
    this.isModalOpen = true
    window.addEventListener('hide:page-obscure', this.boundHandleModalClose)

    window.dispatchEvent(new CustomEvent('open:modal', {
      detail: {
        width: '500px',
        padding: 'none',
        modalClassAdd: ['discount-modal', `discount-modal-${this.data.trigger}`],
        headerClassAdd: ['absolute', 'h-[80px]', 'top-0', 'left-0', 'right-0', 'z-20'],
        headerClassRemove: ['border-b', 'grid'],
        bodyClassAdd: ['relative', 'z-10', 'p-6', 'tb-in-page-content', 'tb-list-fix'],
        closeClassAdd: ['absolute', 'top-4', 'right-4', 'z-20'],
      },
    }))

    const modal = document.querySelector('reusable-modal')
    const modalBody = modal.querySelector('.reusable-modal__body')
    if (modalBody) {
      modalBody.innerHTML = modalInner
      const btn = modalBody.querySelector('#discount-modal-proceed')
      if (btn) {
        btn.addEventListener('click', () => {
          window.dispatchEvent(new CustomEvent('close:modal'))
        })
      }
    }
  }

  handleModalClose () {
    if (!this.isModalOpen) return
    this.isModalOpen = false
    this.cleanup()

    if (!this.isFreeProductInCart && this.data.freeProductVariantIds.length && !this.productBeingAdded) {
      this.productBeingAdded = true
      this.addFreeProductsToCart()
    }
  }

  cleanup () {
    window.removeEventListener('hide:page-obscure', this.boundHandleModalClose)
    const url = new URL(window.location.href)
    url.searchParams.delete('trigger')
    window.history.replaceState({}, '', url.toString())
  }

  addFreeProductsToCart () {
    if (this.isFreeProductInCart || !this.data.freeProductVariantIds.length) {
      this.productBeingAdded = false
      return
    }

    const toAdd = this.data.freeProductVariantIds.filter(
      vid => !this.cartItems.some(item => item.variant_id === vid),
    )
    if (!toAdd.length) {
      this.productBeingAdded = false
      return
    }
    this.addProductsSequentially(toAdd, 0)
  }

  addProductsSequentially (productsToAdd, index) {
    if (index >= productsToAdd.length) {
      this.isFreeProductInCart = true
      this.productBeingAdded = false
      return
    }

    const variantId = productsToAdd[index]
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: index === productsToAdd.length - 1
          ? ['cart-drawer', 'cart-icon-bubble']
          : undefined,
        sectionsUrl: window.location.pathname,
      }),
    })
      .then(res => res.json())
      .then(data => {
        if (index === productsToAdd.length - 1) {
          const cd = document.querySelector('cart-drawer')
          if (cd && data.sections) cd.renderContents(data)
        }
        this.addProductsSequentially(productsToAdd, index + 1)
      })
      .catch(() => {
        this.addProductsSequentially(productsToAdd, index + 1)
      })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.discountModalInstance = new DiscountModal()
})

export default DiscountModal
